/* eslint-disable @angular-eslint/directive-selector */
import { Component, Directive, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AssetFile, AssetSet } from '@brafton/assets-api';

@Component({
  selector: 'shared-assets-image',
  templateUrl: './assets-image.component.html',
  styleUrls: ['./assets-image.component.scss'],
  host: { class: 'assets-image' },
})
export class SharedAssetImageComponent implements OnInit, OnChanges {
  @Input() assetFile?: AssetFile;
  @Input() assetSet?: AssetSet;
  @Input() size = 120;
  @Input() aspect: '16/9' | '1/1' | '4/3' = '1/1';

  @Output() loaded = new EventEmitter<boolean>();
  @Output() errored = new EventEmitter<boolean>();

  width!: number;
  height!: number;

  ngOnInit() {
    this.width = this.size;
    this.getHeight(this.aspect);
    this.prepAsset();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.prepAsset();
  }

  private prepAsset() {
    if (this.assetSet && this.assetSet?.assetFiles?.length > 0) {
      this.assetFile = this.assetSet?.assetFiles[0];
    } else if (this.assetFile == null) {
      this.assetFile = undefined;
    }
  }

  getHeight(aspect: string) {
    if (aspect === '1/1') this.height = this.size;
    if (aspect === '16/9') this.height = Math.trunc(this.size / 1.77);
    if (aspect === '4/3') this.height = Math.trunc(this.size / 1.33);
  }
}

@Directive({
  selector: 'shared-asset-image-content',
  host: { class: 'asset-image-content' },
})
export class SharedAssetImageContentDirective {}
